// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FfjTmr__Wh2SCqSqbKzC-","field":"I3dNfJGfyIrT-ICb5C9fH","newPriceFields":"_1mpL0eZ9xek7Dblv0AOhoc","pricesList":"_1ZIbpeH0YPSPjofqOBP_-5"};